import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";

import { navigate } from "gatsby";
import svgImgFtr from "../../static/media/Images/footerCamBtn.svg";

if (typeof window != 'undefined') {
  var QrReader = require('react-qr-reader')
}
const useStyles = makeStyles(theme => ({
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  },
  grRdrBtn: {
    width: "inherit",
    '& .MuiButton-label': {
      width: "inherit",
    },
    '& img': {
      width: "inherit",
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const testes = state => {
  //   // result: "No result";
  // };

  const handleScan = (data) => {
    if (data) {

      if (data.substring(0, 17) === 'tecvitlikuran.org') {
        navigate(data.substring(17))
      } 
    
    }
  };
  const handleError = err => {
    console.error(err);
  };
  // const handleCodeScanned = () => {
  //   navigate(state.result);
  // };
  // const handleChange = (event) => {
  //   setState({ value: event.target.value });
  // }

  // let qrtest = ''
  // const qrcdreaded = url
  // const qrcdreaded2 = qrcdreaded ? qrcdreaded.substring(17) : 'no'
  // const tes = qrcdreaded ? qrcdreaded.substring(0, 17) : 'no'

  // if (tes === 'tecvitlikuran.org') {
  // qrtest = event => {
  //     event.preventDefault()
  //     // TODO: do something with form values
  //     navigate(qrcdreaded2)
  //   }
  // } 

  return (
    <>
      <Button color="primary" onClick={handleClickOpen} className={classes.grRdrBtn}>
        <img src={svgImgFtr} alt="footer QR Code reader" />
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              QR
            </Typography>
          </Toolbar>
        </AppBar>
        <div>
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            // onImageLoad={navigate(qrcdreaded2)}
            style={{ width: "100%" }}
          />

        </div>
      </Dialog>
    </>
  );
}
